import { PlaceRef } from "@/types/entity"
import { ExploreLocation, ExploreType } from "@/types/explore"
import { AxiosInstance } from "axios"

import { ExploreApi } from "./explore-api"
import { formatPlaceType } from "./format-utils"

export function formatExploreType(type: ExploreType): string {
  switch (type) {
    case "all":
      return "For you"
    case "guide":
      return "Guides"
    default:
      return type === "attraction"
        ? "Experiences"
        : formatPlaceType(type, true, true)
  }
}

export async function fetchExploreProps(
  axios: AxiosInstance,
  query: { loc?: PlaceRef }
) {
  const exploreApi = new ExploreApi(axios)
  const location = await exploreApi.fetchExploreLocation(query.loc)

  return {
    location: location as ExploreLocation,
  }
}
